import PropTypes from "prop-types";

import PremierPageFrameContainer from "../../containers/PremierPageFrameContainer/index.jsx";
import PremierErrorContainer from "../../containers/PremierErrorContainer/index.jsx";
import PremierHeroContainer from "../../containers/PremierHeroContainer/index.jsx";
import PremierDeliveryNoticeContainer from "../../containers/PremierDeliveryNoticeContainer/index.jsx";
import PremierUnavailableMessageContainer from "../../containers/PremierUnavailableMessageContainer/index.jsx";
import CountrySelectorContainer from "../../containers/CountrySelectorContainer/index.jsx";
import PremierSelectorOptionsContainer from "../../containers/PremierSelectorOptionsContainer/index.jsx";
import PremierPropositionContainer from "../../containers/PremierPropositionContainer/index.jsx";
import PremierPricingTableContainer from "../../containers/PremierPricingTableContainer/index.jsx";
import PremierDeliveryFAQsContainer from "../../containers/PremierDeliveryFAQsContainer/index.jsx";
import PremierPromotionalMessageContainer from "../PremierPromotionalMessageContainer/index.jsx";

const PremierLandingPageLayout = ({ appConfig }) => (
  <div className="PremierLandingPageWrapper">
    <PremierErrorContainer />
    <PremierPageFrameContainer>
      <div className="PremierContentContainer">
        <PremierHeroContainer />
        <PremierUnavailableMessageContainer />
        <PremierDeliveryNoticeContainer appConfig={appConfig} />
        <CountrySelectorContainer />
        <PremierSelectorOptionsContainer />
        <PremierPromotionalMessageContainer />
        <PremierPropositionContainer appConfig={appConfig} />
        <PremierPricingTableContainer />
        <PremierDeliveryFAQsContainer />
      </div>
    </PremierPageFrameContainer>
  </div>
);

PremierLandingPageLayout.propTypes = {
  appConfig: PropTypes.object,
};

export default PremierLandingPageLayout;
